export const HOME = '/mfe/hoteis';
export const CHECKOUT = '/mfe/hoteis/checkout';
export const RESULTS = '/mfe/hoteis/resultados';
export const FAQ = '/mfe/hoteis/faq';
export const DETAILS = '/mfe/hoteis/detalhes';
export const MY_HOTELS = '/restrito/meus-hoteis';
export const MY_HOTELS_STATUS = '/restrito/meus-hoteis/:pageSection';
export const MY_HOTELS_DETAILS = '/restrito/meus-hoteis/detalhes/:id';
export const COMPARATOR_HOTELS = '/mfe/hoteis/comparar-hoteis';
